import { IPlasticCardResponse, RequestCard } from '../contracts';

export const RequestCardStub: RequestCard = async () => {
  return await Promise.resolve(requestPlasticCardResponseStub);
};

export const requestPlasticCardResponseStub: IPlasticCardResponse = {
  status: 'success',
  data: { ClubCode: '215', MembershipNumber: '6202150201710700', CustomerId: 'some-customer-id' },
};
